import { render, staticRenderFns } from "./WiedervorlageDialog.vue?vue&type=template&id=2deb1388&scoped=true"
import script from "./WiedervorlageDialog.vue?vue&type=script&lang=js"
export * from "./WiedervorlageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb1388",
  null
  
)

export default component.exports